import {
  AssignUserToCargoCompanyRequest,
  CargoCompany,
  CargoCompanyDetail,
  CargoCompanyFilters,
  CargoCompanyUser,
  CreateCargoCompanyRequest,
  UpdateCargoCompanyRequest,
} from "../types/cargoCompany";
import { ApiResponse } from "../types/common";
import { ApiClient } from "./apiClient";

const cargoCompanyService = new ApiClient<CargoCompany>(
  "/admin/cargo-companies"
);

// Get all cargo companies
export const getCargoCompanies = (
  filters?: CargoCompanyFilters
): Promise<ApiResponse<CargoCompany[]>> => {
  return cargoCompanyService.custom(
    "get",
    "",
    undefined,
    filters ? { params: filters } : undefined
  );
};

// Get cargo company by ID
export const getCargoCompany = (
  id: string
): Promise<ApiResponse<CargoCompany>> => {
  return cargoCompanyService.get(id);
};

// Get cargo company detail (with users)
export const getCargoCompanyDetail = (
  id: string
): Promise<ApiResponse<CargoCompanyDetail>> => {
  return cargoCompanyService.custom("get", `/${id}/detail`);
};

// Create cargo company
export const createCargoCompany = (
  data: CreateCargoCompanyRequest
): Promise<ApiResponse<CargoCompany>> => {
  return cargoCompanyService.create(data);
};

// Update cargo company
export const updateCargoCompany = (
  id: string,
  data: UpdateCargoCompanyRequest
): Promise<ApiResponse<CargoCompany>> => {
  return cargoCompanyService.update(id, data);
};

// Delete cargo company
export const deleteCargoCompany = (
  id: string
): Promise<ApiResponse<object>> => {
  return cargoCompanyService.custom("delete", `/${id}`);
};

// Get users assigned to cargo company
export const getCargoCompanyUsers = (
  id: string,
  activeOnly = true
): Promise<ApiResponse<CargoCompanyUser[]>> => {
  return cargoCompanyService.custom("get", `/${id}/users`, undefined, {
    params: { activeOnly },
  });
};

// Assign user to cargo company
export const assignUserToCargoCompany = (
  id: string,
  data: AssignUserToCargoCompanyRequest
): Promise<ApiResponse<CargoCompanyUser>> => {
  return cargoCompanyService.custom("post", `/${id}/users`, data);
};

// Remove user from cargo company
export const removeUserFromCargoCompany = (
  id: string,
  userId: string
): Promise<ApiResponse<object>> => {
  return cargoCompanyService.custom("delete", `/${id}/users/${userId}`);
};

// Export default service object
const CargoCompanyService = {
  getCargoCompanies,
  getCargoCompany,
  getCargoCompanyDetail,
  createCargoCompany,
  updateCargoCompany,
  deleteCargoCompany,
  getCargoCompanyUsers,
  assignUserToCargoCompany,
  removeUserFromCargoCompany,
};

export default CargoCompanyService;
